import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { NgcCookieConsentService } from 'ngx-cookieconsent';

@Component({
    selector: 'app-not-available',
    templateUrl: './not-available.component.html',
    styleUrls: ['./not-available.component.scss']
})
export class NotAvailableComponent implements OnInit {

    constructor(
        private titleService: Title, 
        private matDialog: MatDialog, 
        private cookieConsentService: NgcCookieConsentService) { }

    ngOnInit() {

        this.titleService.setTitle('Página no disponible :(');
        this.matDialog.closeAll();
        this.cookieConsentService.close(false);

    }

}
